import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeValue } from '@angular/platform-browser';

type SafePipeType = 'html' | 'style' | 'script' | 'url' | 'resourceUrl' | 'default';

@Pipe({
  name: 'safe',
  pure: true,
  standalone: true,
})
export class SafePipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  public transform(value: string, type: SafePipeType): SafeValue {
    switch (type) {
      case 'html':
        return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'style':
        return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script':
        return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl':
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        throw new Error(`SafePipe unable to bypass security for invalid type: ${type}`);
    }
  }
}
